import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {BusinessOrder, BusinessOrderReproduction, BusinessOrderView} from '../models/business-order.models';
import {BusinessOrderStepView} from '../models/business-order-step.models';
import {FetchPositionWithFetchAndFrame} from '../../models/fetch.models';
import {LoadingWrapper} from '../../../../common/loading/loading-wrapper';
import {BusinessOrderGoodpieces} from './goodpiece-box/business-order-view-goodpiece-box.models';
import {BusinessOrderViewGoodpieceService} from './goodpiece-box/business-order-view-goodpiece.service';
import {of} from 'rxjs';
import {BusinessOrderService} from '../services/business-order.service';
import {Comment} from '../../../comment/comment.models';

@Component({
    selector: 'business-order-view',
    templateUrl: './business-order-view.component.html',
    styles: [
        '.label-spacer {margin-left: 100px;}',
        '.ba-label-row {margin-top: 5px; font-size: 18px !important;}',
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BusinessOrderViewComponent implements OnInit {
  @Input() data: BusinessOrderView;
  @Input() fetches: FetchPositionWithFetchAndFrame[];
  goodpieces: LoadingWrapper<BusinessOrderGoodpieces>;
  ba: BusinessOrder;
  reproduction?: BusinessOrderReproduction;
  steps: BusinessOrderStepView[];
  comments: Comment[];
  item: string;
  workflowWarning: boolean;
  has_plugging: boolean;
  has_copper_filling: boolean;
  showMaterialsWithCharge: boolean = false;
  currentStep: BusinessOrderStepView | null = null;

  constructor(private service: BusinessOrderService,
              private goodpieceService: BusinessOrderViewGoodpieceService) {
  }

  ngOnInit(): void {
    this.setData(this.data);
  }

  setData(data: BusinessOrderView): void {
    this.workflowWarning = data.workflow_status >= 100;
    this.ba = data.object;
    this.steps = data.steps;
    this.reproduction = data.reproduction;
    this.item = this.ba.id + '-' + this.ba.index;
    this.has_plugging = data.article.data.via_plugging || data.article.data.plugging_core;
    this.has_copper_filling = data.article.data.cu_filling || data.article.data.cu_filling_core;
    this.comments = data.comments;
    this.showMaterialsWithCharge = ((this.ba.status > 0) && (this.ba.status < 100)) || (this.ba.status === 150);
    this.currentStep = this.steps.find(s => s.ordering === this.ba.current_step_ordering && !s.end_date) ?? null;
  }

  updateGoodPiece(): void {
    this.goodpieces = new LoadingWrapper(this.goodpieceService.get(this.ba.id, this.ba.index));
  }

  setGoodPiece(goodpieces: BusinessOrderGoodpieces): void {
    this.goodpieces = new LoadingWrapper(of(goodpieces));
  }

  updateReproduction(reproduction: BusinessOrderReproduction): void {
    this.reproduction = reproduction;
  }

  updateData(): void {
    this.service.detail(this.ba.id, this.ba.index).subscribe(ba => {
      this.setData(ba);
    });
  }

}
